import { useError } from 'src/hooks/useError'
import { UserTranslator } from 'src/translators'
import { useGetUserQuery } from 'src/types/generated'

type Input = {
  userId: number
}

export const useGetUser = ({ userId }: Input) => {
  const { loading, data, error, refetch } = useGetUserQuery({ variables: { userId } })
  const { toErrorEntities } = useError()

  return {
    loading,
    user: data && data.user ? UserTranslator.toUserDetailEntity(data.user.user) : null,
    errors: error ? toErrorEntities(error) : null,
    refetch,
  }
}
